var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bb-view-filter" },
    [
      _c(
        "b-form-group",
        [
          _c("b-form-radio-group", {
            ref: "switchView",
            attrs: {
              id: "bb_view_filter_toggle",
              options: _vm.calendarViews,
              buttons: "",
              name: "radios-btn-default",
            },
            on: {
              change: function ($event) {
                return _vm.switchView()
              },
            },
            model: {
              value: _vm.selectedView,
              callback: function ($$v) {
                _vm.selectedView = $$v
              },
              expression: "selectedView",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }